import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.ends-with";
import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module block-quote/blockquoteediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import BlockQuoteCommand from "./blockquotecommand";
/**
 * The block quote editing.
 *
 * Introduces the `'blockQuote'` command and the `'blockQuote'` model element.
 *
 * @extends module:core/plugin~Plugin
 */

var BlockQuoteEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(BlockQuoteEditing, _Plugin);

  function BlockQuoteEditing() {
    _classCallCheck(this, BlockQuoteEditing);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockQuoteEditing).apply(this, arguments));
  }

  _createClass(BlockQuoteEditing, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      editor.commands.add('blockQuote', new BlockQuoteCommand(editor));
      schema.register('blockQuote', {
        allowWhere: '$block',
        allowContentOf: '$root'
      }); // Disallow blockQuote in blockQuote.

      schema.addChildCheck(function (ctx, childDef) {
        if (ctx.endsWith('blockQuote') && childDef.name == 'blockQuote') {
          return false;
        }
      });
      editor.conversion.elementToElement({
        model: 'blockQuote',
        view: 'blockquote'
      }); // Postfixer which cleans incorrect model states connected with block quotes.

      editor.model.document.registerPostFixer(function (writer) {
        var changes = editor.model.document.differ.getChanges();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entry = _step.value;

            if (entry.type == 'insert') {
              var element = entry.position.nodeAfter;

              if (!element) {
                // We are inside a text node.
                continue;
              }

              if (element.is('blockQuote') && element.isEmpty) {
                // Added an empty blockQuote - remove it.
                writer.remove(element);
                return true;
              } else if (element.is('blockQuote') && !schema.checkChild(entry.position, element)) {
                // Added a blockQuote in incorrect place - most likely inside another blockQuote. Unwrap it
                // so the content inside is not lost.
                writer.unwrap(element);
                return true;
              } else if (element.is('element')) {
                // Just added an element. Check its children to see if there are no nested blockQuotes somewhere inside.
                var range = writer.createRangeIn(element);
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = range.getItems()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var child = _step2.value;

                    if (child.is('blockQuote') && !schema.checkChild(writer.createPositionBefore(child), child)) {
                      writer.unwrap(child);
                      return true;
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            } else if (entry.type == 'remove') {
              var parent = entry.position.parent;

              if (parent.is('blockQuote') && parent.isEmpty) {
                // Something got removed and now blockQuote is empty. Remove the blockQuote as well.
                writer.remove(parent);
                return true;
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var _this = this;

      var editor = this.editor;
      var command = editor.commands.get('blockQuote'); // Overwrite default Enter key behavior.
      // If Enter key is pressed with selection collapsed in empty block inside a quote, break the quote.
      // This listener is added in afterInit in order to register it after list's feature listener.
      // We can't use a priority for this, because 'low' is already used by the enter feature, unless
      // we'd use numeric priority in this case.

      this.listenTo(this.editor.editing.view.document, 'enter', function (evt, data) {
        var doc = _this.editor.model.document;
        var positionParent = doc.selection.getLastPosition().parent;

        if (doc.selection.isCollapsed && positionParent.isEmpty && command.value) {
          _this.editor.execute('blockQuote');

          _this.editor.editing.view.scrollToTheSelection();

          data.preventDefault();
          evt.stop();
        }
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'BlockQuoteEditing';
    }
  }]);

  return BlockQuoteEditing;
}(Plugin);

export { BlockQuoteEditing as default };